import * as React from 'react'
import { connect } from 'react-redux'

import { Menu, DynamicCx } from 'common/types'
import { styling } from 'common/utils'
import hostConfig from 'common/config'
import { isWindowService, getVerticalPath, isReactHome } from 'common/constants'
import { VerticalContext } from 'common/context'
import Link from 'common/components/Link'
import { initializeBrands } from 'common/ducks/brand'

import Flag from './Flag'
import SubLinks from './SubLinks'

import * as s from './lnb.scss'

interface DispatchProps {
  initializeBrands: typeof initializeBrands
}

interface OwnProps {
  menu: Menu
  cx?: DynamicCx
}

type Props = DispatchProps & OwnProps

const LnbLink: React.SFC<Props> = props => {
  const { menu, cx } = props

  // When ducks need initialization
  const handleInitializeDucks = () => {
    props.initializeBrands()
  }

  return (
    <VerticalContext.Consumer>
      {({ vertical }) => (
        <li className={cx(menu.className)}>
          {isReactHome(menu.vertical) ? (
            <Link
              to={`${menu.to}/home`}
              className={cx({ active: menu.vertical === vertical }, menu.nclick)}
              onClick={handleInitializeDucks}>
              <span className={cx('txt')}>{menu.title}</span>
              {menu.flag && <Flag flag={menu.flag} />}
            </Link>
          ) : (
            <a
              href={`${isWindowService(menu.to) ? hostConfig.windowUri.pc : hostConfig.verticalUri.pc}${menu.to}`}
              className={cx({ active: menu.to === getVerticalPath(vertical) }, menu.nclick)}>
              <span className={cx('txt')}>{menu.title}</span>
              {menu.flag && <Flag flag={menu.flag} />}
            </a>
          )}
          {menu.subMenus && menu.subMenus.length && <SubLinks subMenus={menu.subMenus} />}
        </li>
      )}
    </VerticalContext.Consumer>
  )
}

export default connect<null, DispatchProps, OwnProps>(
  null,
  {
    initializeBrands,
  },
)(styling(s)(LnbLink))
